export default "__VITE_ASSET__T_INmNcq__"